<template>
  <div class="w-dyn-item w-col w-col-4 portfolio-item">
    <router-link
      class="w-inline-block recent-work-block"
      :style="backgroundImage('image')"
      :to="{ name: 'Project', params: { slug: project.slug}}"
    >
      <div class="featured-work-block-overlay">
        <div class="featured-work-title-wrapper">
          <div class="recent-work-title">
            {{ project.title }}
          </div>
          <div class="recent-work-title subtitle">
            {{ project.subtitle }}
          </div>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    project: {
      required: true,
      type: Object,
    },
  },

  methods: {
    backgroundImage(articleKey) {
      return {
        // eslint-disable-next-line
        'background-image': `url('${this.imagePath(articleKey)}')`,
      }
    },
    imagePath(articleKey) {
      let photo
      if (this.project) {
        // eslint-disable-next-line
        photo = require(`../assets/project_photos/${this.project[articleKey]}`)
      }
      return photo
    },
  },
}
</script>
